import Scrrroll from 'scrrroll';
import datepicker from 'js-datepicker'
import { isIE } from '@gelato/utils/features';

export default function(dom, opts) {
	let options = {
		...opts
  };

  if (dom.classList.contains('contact__form')) {
    const reason = dom.querySelector('select[name="reason"]');
    const fieldset = dom.querySelector('fieldset.contact__request-fields');

    if (reason && fieldset) {
      reason.addEventListener('change', e => {
        if (reason.value === 'request') {
          fieldset.classList.add('contact__request-fields--active');
        }
        else {
          fieldset.classList.remove('contact__request-fields--active');
          Array.from(fieldset.querySelectorAll('input, textarea')).forEach(input => {
            input.value = input.defaultValue;
          });
        }
      });
    }
  }

  if (!isIE) {
    const dateInputs = Array.from(dom.querySelectorAll('.input-field--date'));

    dateInputs.forEach(dateInput => {
      dateInput.setAttribute('autocomplete', 'off');
      dateInput.setAttribute('readonly', true);
      const picker = datepicker(dateInput, {
        startDay: 1,
        minDate: new Date(),
        noWeekends: true,
        disableYearOverlay: true,
        customDays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        customMonths: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        formatter: (input, date, instance) => {
          const value = date.toLocaleDateString('de-DE');
          input.value = value;
        }
      })
    });
  }

  if (dom.noValidate) {
    const requireds = Array.from(dom.querySelectorAll('input[required], textarea[required]'));

    dom.addEventListener('submit', e => {
      let error = false;
      let firstError;

      requireds.forEach(field => {
        let fieldError = false;

        if (field.type === 'text' || field.type === 'textarea') {
          fieldError = field.value.trim().length < 2;
          error = error || fieldError;
        }
        else if (field.type === 'email') {
          fieldError = !(/^[\u00C0-\u017Fa-zA-Z0-9](([_\.\-\+]?[_\.\-\+\u00C0-\u017Fa-zA-Z0-9]+)*)@(xn--)?([\u00C0-\u017Fa-zA-Z0-9]+)(([\.\-]?[\u00C0-\u017Fa-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/i).test(field.value);
          error = error || fieldError;
        }

        if (fieldError) {
          firstError = firstError || field;
          field.parentNode.classList.add('primary-input--error');
        }
        else {
          field.parentNode.classList.remove('primary-input--error');
        }
      });

      if (error) {
        e.preventDefault();
        Scrrroll.to(firstError);
        firstError.focus();
        return false;
      }
    });
  }
}
